import { Route, Routes } from "react-router-dom"
import SignUp from "./SignUp.jsx"
import SignIn from "./SignIn.jsx"
import ForgotPassword from "./ForgotPassword.jsx"
import ResetPassword from "./ResetPassword.jsx"
import SwitchMarketSignUp from "./SwitchMarketSignUp.jsx"

export default function Sign() {
  return (
    <div className="h-full overflow-y-auto bg-background">
      <Routes>
        <Route path="in" element={<SignIn />} />
        <Route path="up" element={<SignUp />} />
        <Route path="up/switch-markets" element={<SwitchMarketSignUp />} />
        <Route path="forgot" element={<ForgotPassword />} />
        <Route path="reset/:token" element={<ResetPassword />} />
      </Routes>
    </div>
  )
}
